module.exports = __webpack_public_path__ + "img/job-search.5c78bb4c.svg";